<p-button
  type="button"
  [rounded]="true"
  variant="outlined"
  [severity]="notifService.noLeidas() > 0 ? 'warn' : 'secondary'"
  icon="pi pi-bell"
  [badge]="notifService.noLeidas() > 0 ? notifService.noLeidas().toString() : ''"
  badgeSeverity="danger"
  pTooltip="Notificaciones"
  tooltipPosition="bottom"
  [showDelay]="800"
  (onClick)="campana.toggle($event)"
></p-button>

<p-popover #campana appendTo="body" [style]="{ width: '340px', maxWidth: '95vw' }">
  <!-- Cabecera -->
  <div class="campana-header">
    <span style="font-size: var(--p-font-size)">Avisos</span>
    @if (notifService.noLeidas() > 0) {
      <button
        class="campana-link"
        (click)="marcarTodas()"
        (keydown.enter)="marcarTodas()"
        tabindex="0"
      >
        Marcar como leídas
      </button>
    }
  </div>

  <!-- Lista -->
  <div class="campana-lista">
    @if (notifService.cargando()) {
      <div class="flex justify-center py-6">
        <i
          class="pi pi-spin pi-spinner"
          style="font-size: 1.5rem; color: var(--p-text-muted-color)"
        ></i>
      </div>
    } @else if (notifService.notificaciones().length === 0) {
      <div class="flex justify-center py-6 px-4">
        <i
          class="pi pi-bell-slash"
          style="font-size: 1.75rem; color: var(--p-text-muted-color)"
        ></i>
      </div>
    } @else {
      @for (notif of notifService.notificaciones(); track notif.id) {
        <div
          class="notif-item"
          [class.unread]="!notif.leida"
          (click)="abrir(notif)"
          (keydown.enter)="abrir(notif)"
          tabindex="0"
          role="button"
        >
          <i
            class="pi {{ iconoPara(notif) }} flex-shrink-0"
            [style.opacity]="notif.leida ? '0.45' : '1'"
          ></i>
          <div class="flex-1 min-w-0">
            <div class="flex items-center justify-between gap-2">
              <span class="text-sm truncate" [style.opacity]="notif.leida ? '0.55' : '1'">{{
                notif.titulo
              }}</span>
              @if (!notif.leida) {
                <span class="notif-dot"></span>
              }
            </div>
            <span class="notif-tiempo">{{ tiempoRelativo(notif.createdAt) }}</span>
          </div>
        </div>
      }
    }
  </div>

  <!-- Pie -->
  <div class="campana-footer">
    <button
      class="campana-link campana-link--center"
      (click)="verTodas()"
      (keydown.enter)="verTodas()"
      tabindex="0"
    >
      Ver todas
    </button>
  </div>
</p-popover>
